import { httpClient } from '@/services/http/httpClient'

export async function activeIdea(ideaId: string): Promise<void> {
  await httpClient.put(`/ideas/ideas/${ideaId}/active`)
}
